import React from 'react';
// import Navbar from 'react-bootstrap/Navbar';
import './Footer.css';

class Footer extends React.Component {
  render() {
    return (

<div className='footer'>
 <p> Copyright &copy; 2023 SkyWatchers </p>
              </div>
    );
  }
}

export default Footer;